export const ValidRegex = {
  EMAIL_REGEX: /^(?!.*@.*\.localhost$)[A-Z0-9_+%-]+(?:\.[A-Z0-9_+%-]+)*@(?:[A-Z0-9](?:[A-Z0-9-]*[A-Z0-9])?\.)+[A-Z]{2,}$/i
};